module.exports = __webpack_public_path__ + "img/server.18e0e81b.png";